import { IUserPreferences, IUserPreferencesAction } from 'models/user/userpreferences';
import { IStore } from 'redux/IStore';
import { changeLanguage } from 'redux/modules/user/userlanguage';
import * as i18n from 'i18next';
import { actions as notifActions } from 'redux-notifications';
import { cookies } from 'helpers/cookies';
import * as c from 'models/constants';
import { showPreloader } from 'redux/modules/preloader';
import { IShopCard } from 'models/shop/shopcard';
import { ILanguage } from 'models/common';
import { setAuthenticationData } from 'redux/modules/fetch';
import { checkForNewNotifications } from 'redux/modules/notifications/notificationsdropdown';
import { IUserRole } from 'models/shop/members';
const detectBrowserLanguage = require('detect-browser-language');
const { notifSend } = notifActions;

const emailConfirmedCallbackUrl = '/emailconfirmed';

/** Action Types */
export const GET_REQUEST: string = 'userpreference/GET_REQUEST';
export const GET_SUCCESS: string = 'userpreference/GET_SUCCESS';
export const GET_FAILURE: string = 'userpreference/GET_FAILURE';

export const PUT_REQUEST: string = 'userpreference/PUT_REQUEST';
export const PUT_SUCCESS: string = 'userpreference/PUT_SUCCESS';
export const PUT_FAILURE: string = 'userpreference/PUT_FAILURE';

export const GET_USER_SHOPS_REQUEST: string = 'userpreference/GET_USER_SHOPS_REQUEST';
export const GET_USER_SHOPS_SUCCESS: string = 'userpreference/GET_USER_SHOPS_SUCCESS';
export const GET_USER_SHOPS_FAILURE: string = 'userpreference/GET_USER_SHOPS_FAILURE';

export const GET_USER_PERMISSION_REQUEST: string = 'userpreference/GET_USER_PERMISSION_REQUEST';
export const GET_USER_PERMISSION_SUCCESS: string = 'userpreference/GET_USER_PERMISSION_SUCCESS';
export const GET_USER_PERMISSION_FAILURE: string = 'userpreference/GET_USER_PERMISSION_FAILURE';

export const SEND_VERIFICATION_EMAIL_SUCCESS: string = 'userpreference/SEND_VERIFICATION_EMAIL_SUCCESS';

export const PUT_ACTIVE_MEMBERS_SUCCESS: string = 'userprefrence/SET_ACTIVE_MEMBERS_SUCCESS';

/** Initial State */
const initialState: IUserPreferences = {
	message: '',
	isFetching: false,
	error: false,
	languageKey: null,
	zoneInfo: '',
	isPublic: false,
	messageSubscription: 0,
	callingCodeKey: null,
	phoneNumber: '',
	isSMSNotificationEnabled: false,
	isEmailNotificationEnabled: true,
	isWebNotificationEnabled: true,
	id: null,
	emailVerified: false,
	timeZones: [],
	currencies: [],
	profilePicture: '',
	name: '',
	givenName: '',
	familyName: '',
	code: null,
	tokenBalance: null,
	userShops: null,
	activityArticlesVisible: false,
	activityCommentsVisible: false,
	activityLikesVisible: false,
	activityStylesVisible: false,
	activityWishlistVisible: false,
	activityFollowsVisible: false,
	activityWardrobeItemsVisible: false,
	activityOutfitsVisible: false,
	notificationArticlesEnabled: false,
	notificationCommentsEnabled: false,
	notificationFollowsEnabled: false,
	notificationLikesEnabled: false,
	notificationOrderPendingEnabled: false,
	notificationOutfitsEnabled: false,
	notificationProductReturnEnabled: false,
	notificationShopCommentEnabled: false,
	notificationStylesEnabled: false,
	notificationWardrobeItemsEnabled: false,
	notificationWishlistEnabled: false,
	notificationFollowingBirthdayEnabled: false,
	notificationOrderShippedEnabled: false,
	notificationWishlistOnSaleEnabled: false,
	notificationWishlistOnStockEnabled: false,
	notificationAppointmentReminderEnabled: false,
};

/** Reducer */
export function userPreferencesReducer(state = initialState, action: IUserPreferencesAction) {
	switch (action.type) {
		case GET_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				languageKey: action.payload.preferences.languageKey,
				zoneInfo: action.payload.preferences.zoneInfo,
				isPublic: action.payload.preferences.isPublic,
				messageSubscription: action.payload.preferences.messageSubscription,
				phoneNumber: action.payload.preferences.phoneNumber,
				callingCodeKey: action.payload.preferences.callingCodeKey,
				isSMSNotificationEnabled: action.payload.preferences.isSMSNotificationEnabled,
				isEmailNotificationEnabled: action.payload.preferences.isEmailNotificationEnabled,
				isWebNotificationEnabled: action.payload.preferences.isWebNotificationEnabled,
				id: action.payload.preferences.id,
				timeZones: action.payload.preferences.timeZones,
				emailVerified: action.payload.preferences.emailVerified,
				isAdministrator: action.payload.preferences.isAdministrator,
				isEditor: action.payload.preferences.isEditor,
				email: action.payload.preferences.email,
				profilePicture: action.payload.preferences.profilePicture,
				name: action.payload.preferences.name,
				givenName: action.payload.preferences.givenName,
				familyName: action.payload.preferences.familyName,
				code: action.payload.preferences.code,
				addedDate: action.payload.preferences.addedDate,
				gender: action.payload.preferences.gender,
				tokenBalance: action.payload.preferences.tokenBalance,
				activityArticlesVisible: action.payload.preferences.activityArticlesVisible,
				activityCommentsVisible: action.payload.preferences.activityCommentsVisible,
				activityLikesVisible: action.payload.preferences.activityLikesVisible,
				activityStylesVisible: action.payload.preferences.activityStylesVisible,
				activityWishlistVisible: action.payload.preferences.activityWishlistVisible,
				activityFollowsVisible: action.payload.preferences.activityFollowsVisible,
				activityWardrobeItemsVisible: action.payload.preferences.activityWardrobeItemsVisible,
				activityOutfitsVisible: action.payload.preferences.activityOutfitsVisible,
				notificationArticlesEnabled: action.payload.preferences.notificationArticlesEnabled,
				notificationCommentsEnabled: action.payload.preferences.notificationCommentsEnabled,
				notificationFollowsEnabled: action.payload.preferences.notificationFollowsEnabled,
				notificationLikesEnabled: action.payload.preferences.notificationLikesEnabled,
				notificationOrderPendingEnabled: action.payload.preferences.notificationOrderPendingEnabled,
				notificationOutfitsEnabled: action.payload.preferences.notificationOutfitsEnabled,
				notificationProductReturnEnabled: action.payload.preferences.notificationProductReturnEnabled,
				notificationShopCommentEnabled: action.payload.preferences.notificationShopCommentEnabled,
				notificationStylesEnabled: action.payload.preferences.notificationStylesEnabled,
				notificationWardrobeItemsEnabled: action.payload.preferences.notificationWardrobeItemsEnabled,
				notificationWishlistEnabled: action.payload.preferences.notificationWishlistEnabled,
				notificationFollowingBirthdayEnabled: action.payload.preferences.notificationFollowingBirthdayEnabled,
				notificationOrderShippedEnabled: action.payload.preferences.notificationOrderShippedEnabled,
				notificationWishlistOnSaleEnabled: action.payload.preferences.notificationWishlistOnSaleEnabled,
				notificationWishlistOnStockEnabled: action.payload.preferences.notificationWishlistOnStockEnabled,
				notificationAppointmentReminderEnabled: action.payload.preferences.notificationAppointmentReminderEnabled,
			});

		case GET_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case PUT_REQUEST:
			return Object.assign({}, state, {
				isFetching: true,
			});

		case PUT_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				languageKey: action.payload.preferences.languageKey,
				zoneInfo: action.payload.preferences.zoneInfo,
				isPublic: action.payload.preferences.isPublic,
				messageSubscription: action.payload.preferences.messageSubscription,
				callingCodeKey: action.payload.preferences.callingCodeKey,
				phoneNumber: action.payload.preferences.phoneNumber,
				isSMSNotificationEnabled: action.payload.preferences.isSMSNotificationEnabled,
				isEmailNotificationEnabled: action.payload.preferences.isEmailNotificationEnabled,
				isWebNotificationEnabled: action.payload.preferences.isWebNotificationEnabled,
				id: action.payload.preferences.id,
				activityArticlesVisible: action.payload.preferences.activityArticlesVisible,
				activityCommentsVisible: action.payload.preferences.activityCommentsVisible,
				activityLikesVisible: action.payload.preferences.activityLikesVisible,
				activityStylesVisible: action.payload.preferences.activityStylesVisible,
				activityWishlistVisible: action.payload.preferences.activityWishlistVisible,
				activityFollowsVisible: action.payload.preferences.activityFollowsVisible,
				activityWardrobeItemsVisible: action.payload.preferences.activityWardrobeItemsVisible,
				activityOutfitsVisible: action.payload.preferences.activityOutfitsVisible,
				notificationArticlesEnabled: action.payload.preferences.notificationArticlesEnabled,
				notificationCommentsEnabled: action.payload.preferences.notificationCommentsEnabled,
				notificationFollowsEnabled: action.payload.preferences.notificationFollowsEnabled,
				notificationLikesEnabled: action.payload.preferences.notificationLikesEnabled,
				notificationOrderPendingEnabled: action.payload.preferences.notificationOrderPendingEnabled,
				notificationOutfitsEnabled: action.payload.preferences.notificationOutfitsEnabled,
				notificationProductReturnEnabled: action.payload.preferences.notificationProductReturnEnabled,
				notificationShopCommentEnabled: action.payload.preferences.notificationShopCommentEnabled,
				notificationStylesEnabled: action.payload.preferences.notificationStylesEnabled,
				notificationWardrobeItemsEnabled: action.payload.preferences.notificationWardrobeItemsEnabled,
				notificationWishlistEnabled: action.payload.preferences.notificationWishlistEnabled,
				notificationFollowingBirthdayEnabled: action.payload.preferences.notificationFollowingBirthdayEnabled,
				notificationOrderShippedEnabled: action.payload.preferences.notificationOrderShippedEnabled,
				notificationWishlistOnSaleEnabled: action.payload.preferences.notificationWishlistOnSaleEnabled,
				notificationWishlistOnStockEnabled: action.payload.preferences.notificationWishlistOnStockEnabled,
				notificationAppointmentReminderEnabled: action.payload.preferences.notificationAppointmentReminderEnabled,
			});

		case PUT_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case SEND_VERIFICATION_EMAIL_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
				verificationEmailSent: true,
			});

		case GET_USER_SHOPS_SUCCESS:
			return Object.assign({}, state, {
				...state,
				userShops: action.payload.userShops,
				isUserShopsFetching: false,
			});

		case GET_USER_SHOPS_FAILURE:
			return Object.assign({}, state, {
				isUserShopsFetching: false,
				message: action.payload.message,
				error: true,
			});

		case GET_USER_SHOPS_REQUEST:
			return Object.assign({}, state, {
				isUserShopsFetching: true,
				error: false,
			});

		case PUT_ACTIVE_MEMBERS_SUCCESS: {
			return Object.assign({}, state, {
				...state,
				activeMembers: action.payload.activeMembers,
			});
		}
		case GET_USER_PERMISSION_SUCCESS:
			return Object.assign({}, state, {
				...state,
				userRoles: action.payload.userRoles,
			});

		case GET_USER_PERMISSION_FAILURE:
			return Object.assign({}, state, {
				...state,
				isUserShopsFetching: false,
			});

		default:
			return state;
	}
}

/** Async Action Creator */
export function getUserPreferences() {
	return (dispatch, getState: () => IStore) => {
		dispatch(request());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/userpreferences',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => dispatch(userPreferencesSuccess(res)));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

export function setInitialData(isAuthenticated: boolean) {
	return (dispatch, getState: () => IStore) => {
		if (isAuthenticated) {
			dispatch(setAuthenticationData(localStorage.getItem('access_token')));
		}

		if (!(getState().userPreferences && getState().userPreferences.id) && isAuthenticated) {
			dispatch(getMyUserPreferences()).then(() => {
				dispatch(setLanguageData(isAuthenticated));
			});
		} else {
			dispatch(setLanguageData(isAuthenticated));
			dispatch(showPreloader(false));
		}
	};
}

function setLanguageData(isAuthenticated: boolean) {
	return (dispatch, getState: () => IStore) => {
		const languageCookie = cookies.get(c.COOKIE_KEY_LANGUAGE);
		const langFromUserPreferences = getState().userPreferences.languageKey;
		let lang: ILanguage[] = null;
		if (languageCookie) {
			//check cookie first then preferences
			lang = getState().domainValues.languages.filter((x) => languageCookie === x.culture); //try exact culture ex. en-US
			if (!lang || lang.length === 0) {
				lang = getState().domainValues.languages.filter((x) => languageCookie.slice(0, 2) === x.culture.slice(0, 2)); //try generic culture without specific region ex. en
				if (!lang || lang.length === 0) {
					throw new Error('Language domain value not found');
				}
			}
			if (langFromUserPreferences) {
				dispatch(changeLanguage(langFromUserPreferences, false));
			} else {
				dispatch(changeLanguage(lang[0].key, isAuthenticated));
			}
		} else if (langFromUserPreferences) {
			dispatch(changeLanguage(langFromUserPreferences, false));
		} else {
			// detect browser language for first time and set cookie
			const browserCulture = detectBrowserLanguage();
			lang = getState().domainValues.languages.filter((x) => browserCulture === x.culture);
			if (!lang || lang.length === 0) {
				// check only first two chars
				lang = getState().domainValues.languages.filter((x) => browserCulture.substr(0, 2) === x.culture.substr(0, 2));
				if (!lang || lang.length === 0) {
					// default to english
					lang = getState().domainValues.languages.filter((x) => c.LANGUAGE_EN_US === x.culture);
				}
			}
			dispatch(changeLanguage(lang[0].key, isAuthenticated));
		}
	};
}

/** Async Action Creator */
export function getMyUserPreferences() {
	return (dispatch, getState: () => IStore) => {
		return new Promise((resolve) => {
			dispatch(request());
			fetch(
				getState().fetchDefault.baseAPI + 'api/userpreferences/',
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					if (res.ok) {
						return res.json().then((res: IUserPreferences) => {
							dispatch(userPreferencesSuccess(res));
							dispatch(showPreloader(false));
							dispatch(getUserShops());
							dispatch(getUserPermissions(res.id));
							dispatch(checkForNewNotifications());
							resolve(true);
						});
					} else {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(requestFailure(res));
								resolve(true);
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(requestFailure(message));
								resolve(true);
							});
					}
				})
				.catch((err) => {
					dispatch(requestFailure(err));
					resolve(false);
				});
		});
	};
}

/** Async Action Creator */
export function register(returnUrl?: string) {
	return (dispatch, getState: () => IStore) => {
		return new Promise((resolve) => {
			dispatch(request());

			return fetch(
				getState().fetchDefault.baseAPI + 'userenter/Register?callbackUrl=' + returnUrl,
				Object.assign({}, getState().fetchDefault.requestInit),
			)
				.then((res) => {
					resolve(true);
					if (!res.ok) {
						const status: number = res.status;
						const statusText: string = res.statusText;
						return res
							.json()
							.then((res) => {
								res.status = status;
								res.statusText = statusText;
								dispatch(requestFailure(res));
								resolve(true);
							})
							.catch(() => {
								const message: any = { status, statusText };
								dispatch(requestFailure(message));
								resolve(true);
							});
					}
				})
				.catch((err) => {
					dispatch(requestFailure(err));
					resolve(true);
				});
		});
	};
}

/** Async Action Creator */
export function getUserShops() {
	return (dispatch, getState: () => IStore) => {
		dispatch(getUserShopsRequest());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/shop/GetByUser',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => dispatch(getUserShopsSuccess(res)));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(getUserShopsFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(getUserShopsFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(getUserShopsFailure(err));
			});
	};
}

/** Async Action Creator */
export function sendVerificationEmail() {
	return (dispatch, getState: () => IStore) => {
		dispatch(request());
		return fetch(
			getState().fetchDefault.baseAPI + 'api/userpreferences/',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IUserPreferences) => {
						if (res.emailVerified) {
							dispatch(
								notifSend({
									message: i18n.t('Notification_Success_Email_Already_Confirmed'),
									kind: 'success',
									dismissAfter: 3000,
								}),
							);
							dispatch(userPreferencesSuccess(res));
						} else {
							const url =
								'api/User/SendVerificationEmail?userId=' +
								getState().userPreferences.id +
								'&callbackUrl=' +
								getState().fetchDefault.baseUrlClient +
								emailConfirmedCallbackUrl;
							return fetch(
								getState().fetchDefault.baseAPI + url,
								Object.assign({}, getState().fetchDefault.requestInit),
							)
								.then((res) => {
									if (res.ok) {
										dispatch(sendVerificationEmailSuccess());
										dispatch(
											notifSend({
												message: i18n.t('Notification_Success_Email_Verification_Sent'),
												kind: 'success',
												dismissAfter: 3000,
											}),
										);
									} else {
										const status: number = res.status;
										const statusText: string = res.statusText;
										return res
											.json()
											.then((res) => {
												res.status = status;
												res.statusText = statusText;
												dispatch(requestFailure(res));
											})
											.catch(() => {
												const message: any = { status, statusText };
												dispatch(requestFailure(message));
											});
									}
								})
								.catch((err) => {
									dispatch(requestFailure(err));
								});
						}
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator - update */
export function putUserPreferences(userPreferences: IUserPreferences) {
	return (dispatch, getState: () => IStore) => {
		dispatch(userPreferencesPutRequest());
		const dataToUpdate = userPreferences;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/userpreferences',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'PUT',
				body: JSON.stringify(dataToUpdate),
			}),
		)
			.then((res) => {
				if (res.ok) {
					dispatch(userPreferencesPutSuccess(userPreferences));
					dispatch(
						notifSend({
							message: i18n.t('Notification_Success_User_Preferences_Updated'),
							kind: 'success',
							dismissAfter: 3000,
						}),
					);
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(userPreferencesPutFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(userPreferencesPutFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(userPreferencesPutFailure(err));
			});
	};
}

/** Action Creator */
export function request(): IUserPreferencesAction {
	return {
		type: GET_REQUEST,
	};
}

/** Action Creator */
export function userPreferencesSuccess(preferencesData: IUserPreferences): IUserPreferencesAction {
	return {
		type: GET_SUCCESS,
		payload: {
			preferences: preferencesData,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IUserPreferencesAction {
	return {
		type: GET_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function userPreferencesPutRequest(): IUserPreferencesAction {
	return {
		type: PUT_REQUEST,
	};
}

/** Action Creator */
export function userPreferencesPutSuccess(preferences: any): IUserPreferencesAction {
	return {
		type: PUT_SUCCESS,
		payload: {
			message: 'OK',
			preferences,
		},
	};
}

export function userPreferencesPutFailure(message: any): IUserPreferencesAction {
	return {
		type: PUT_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function sendVerificationEmailSuccess(): IUserPreferencesAction {
	return {
		type: SEND_VERIFICATION_EMAIL_SUCCESS,
	};
}

/** Action Creator */
export function getUserShopsRequest(): IUserPreferencesAction {
	return {
		type: GET_USER_SHOPS_REQUEST,
	};
}

/** Action Creator */
export function getUserShopsFailure(message: any): IUserPreferencesAction {
	return {
		type: GET_USER_SHOPS_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function getUserShopsSuccess(userShops: IShopCard[]): IUserPreferencesAction {
	return {
		type: GET_USER_SHOPS_SUCCESS,
		payload: {
			userShops,
		},
	};
}

export function putActiveMembersSuccess(activeMembers: any[]) {
	return {
		type: PUT_ACTIVE_MEMBERS_SUCCESS,
		payload: {
			activeMembers,
		},
	};
}
function postRequestGeneralSearch(res: any, baseAPI: string) {
	const requestOptions = {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({
			currentPage: 1,
			itemsPerPage: 100,
			typeIds: [3, 10],
			entityIds: res.map((item: any) => item.obj),
		}),
	};

	return fetch(baseAPI + 'api/Search/GeneralSearch', requestOptions);
}

export function getUserPermissions(userId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(userPermissionsRequest());
		return fetch(
			getState().fetchDefault.baseAPI + `api/permission/GetBySubject?id=${userId}`,
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						const rolesWithoutInfo: IUserRole[] = res.map((item: any) => ({
							role: item.actions === 'Read' ? 'Member' : 'Admin',
							objId: JSON.parse(item.obj).id,
							type: JSON.parse(item.obj).type,
						}));

						if (rolesWithoutInfo?.length > 0) {
							postRequestGeneralSearch(res, getState().fetchDefault.baseAPI).then((res: any) => {
								if (res.ok) {
									return res.json().then((res: any) => {
										const roles: IUserRole[] = rolesWithoutInfo.map((role) => {
											// find information about the role object
											const objInfo = res.generalSearches.items.find(
												(infoItem) => role.objId.toLowerCase() == JSON.parse(infoItem?.id)?.id.toLowerCase(),
											);

											// if found, append it to the role
											if (objInfo) {
												return {
													...role,
													objInfo,
												};
											} else {
												return role;
											}
										});
										dispatch(userPermissionsSuccess(roles));
									});
								}
							});
						} else {
							dispatch(userPermissionsSuccess([]));
						}
					});
				}
			})
			.catch((err) => {
				dispatch(userPermissionsFailure(err));
			});
	};
}

export function userPermissionsRequest(): any {
	return {
		type: GET_USER_PERMISSION_REQUEST,
	};
}

export function userPermissionsSuccess(userRoles: IUserRole[]): any {
	return {
		type: GET_USER_PERMISSION_SUCCESS,
		payload: {
			userRoles,
		},
	};
}

export function userPermissionsFailure(message: any): any {
	return {
		type: GET_USER_PERMISSION_FAILURE,
		payload: {
			message,
		},
	};
}
